// import socketIOClient from 'socket.io-client';
import io from "socket.io-client";
// import APP_Constant from "../constants";

// // const socket = io({ path: '/bridge' });
// const socket = socketIOClient(APP_Constant.apiUrl, {
//     agent: false,
//     origins: '*:*',
//     secure: true,
//     rememberUpgrade: true,
//     transports: ['websocket', 'pooling'],
//     rejectUnauthorized: false,
//     upgrade: true,
//   });

// export default socket;

// import { io } from "socket.io-client";


import APP_Constant from "../constants";

const socket = io(APP_Constant.apiUrl, {
  transports: ["websocket"], // use WebSocket first, if available,
  agent: false,
  origins: '*:*',
  secure: true,
  rememberUpgrade: true,
  rejectUnauthorized: false,
  upgrade: true,
  autoConnect: false
});


// socket.on("connect", function (data) {
//   console.log("Doctor connected using main socket ", data);
//   socket.emit('join', "DOCTORS");
// });


export default socket;
